export enum RoleField {
    Name = 'name',
    Description = 'description',
    WRITE_WITHOUT_READ = 'write_without_read'
}

export enum FeatureActions {
    Expand = 1,
    COLLAPSE,
    CHECK_UNCHECK
}

export enum AccessActions {
    READ = 1,
    WRITE
}
